import type { NodeDefinition } from '@shared/types/node-definition';

const definition: NodeDefinition = {
  type: 'langchain-vector-store',
  name: 'LangChain Vector Store',
  description: 'Store and retrieve documents using vector embeddings for semantic search',
  icon: 'Database',
  color: 'purple',
  category: 'ai-nodes',
  tags: ['langchain', 'vector', 'embeddings', 'ai', 'search', 'semantic'],
  comingSoon: true,
  version: '1.0.0',
  inputs: [],
  outputs: [],
};

export default definition;
